import { useEffect, useState, useCallback } from "react";
import { debounce } from "lodash";
import BridgeOfficerSelector from "../BridgeOfficer/BridgeOfficerSelector.js";
import { PlusLg } from "react-bootstrap-icons";

function Sidebar({ data, setData }) {
    const [state, setState] = useState({ types: [] });
    const [name, setName] = useState(data.name ? data.name : "");

    const clearCurrencies = (event) => {
        setData({ ...data, currency: [] });
    }

    const handleFormChange = (event) => {
        let value = event.target.value;
        let newData;

        if (value && value !== '0') {
            newData = {
                ...data,
                [event.target.name]: value,
            };
        } else {
            newData = { ...data };
            delete newData[event.target.name];
        }

        delete newData.start;

        setData(newData);
    };

    const handleMultiCheckboxChange = (event) => {
        const newData = {
            ...data,
        }

        delete newData.start;

        if(!newData[event.target.name]) {
            newData[event.target.name] = [];
        }

        if(!newData[event.target.name].includes(event.target.value)) {
            newData[event.target.name].push(event.target.value);
        } else {
            newData[event.target.name] = newData[event.target.name].filter(item => item !== event.target.value);
        }

        setData(newData);
    }

    const handleCheckboxChange = (event) => {
        const newData = {...data};

        if (event.target.checked) {
            newData[event.target.name] = 1
        } else {
            delete newData[event.target.name];
        }

        delete newData.start;

        setData(newData);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const delayedSearch = useCallback(
        debounce((q) => {
            const newData = { ...data };
            delete newData.start;

            q ? newData['name'] = q : delete newData.name;

            setData(newData);
        }, 500),
        [data]
    );

    const handleNameSearch = (event) => {
        event.preventDefault();
        setName(event.target.value);
        delayedSearch(event.target.value);
    };

    const addBridgeOfficer = (e) => {
        e.preventDefault();
        let newData = { ...data };

        if (!newData.bridge_officers) {
            newData.bridge_officers = [];
        }

        newData.bridge_officers.push({ profession: "" });

        delete newData.start;

        setData(newData);
    };

    const handleMultiSelect = (e) => {
        let value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
            
        const newData = {
            ...data,
            [e.target.name]: value
        };
    
        delete newData.start;

        setData(newData);
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(process.env.REACT_APP_FORM_API);
            const json = await response.json();
            setState(json);
        };

        fetchData();
    }, []);

    return (
        <fieldset name="sidebar" aria-label="sidebar">
            <div className="mb-3">
                <label className="form-label mb-1">Name</label>
                <input
                    type="text"
                    className="form-control bg-primary border-primary text-white"
                    name="name"
                    onChange={handleNameSearch}
                    value={name}
                />
            </div>

            <div className="mb-3">
                <label htmlFor="" className="form-label">
                    Bridge Officers
                </label>

                <div className="d-flex clearfix boff-selector">
                    {data.bridge_officers &&
                        data.bridge_officers.map((item, index) => {
                            return (
                                <BridgeOfficerSelector
                                    key={index}
                                    data={data}
                                    setData={setData}
                                    index={index}
                                />
                            );
                        })}

                    {(!data.bridge_officers ||
                        data.bridge_officers.length < 6) && (
                        <button
                            className="btn btn-success ms-auto"
                            onClick={addBridgeOfficer}
                            aria-label="add bridge officer"
                        >
                            <PlusLg size={"1.25rem"} />
                        </button>
                    )}
                </div>
            </div>

            <div className="mb-3">
                <div className="mb-1">
                    <label htmlFor="faction" className="form-label mb-0">
                        Faction
                    </label>
                </div>
                <div
                    className="checkbox-grid"
                    role="group"
                    aria-label="factions control group"
                >
                    <input
                        type="radio"
                        name="faction"
                        id="all-factions-checkbox"
                        className="btn-check"
                        value=""
                        checked={!data.faction || data.faction === ""}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="all-factions-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        ♾️
                    </label>

                    <input
                        type="radio"
                        name="faction"
                        id="Cross-Faction-checkbox"
                        className="btn-check"
                        value="Cross-Faction"
                        checked={data.faction === "Cross-Faction"}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="Cross-Faction-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        <img
                            src="/img/Faction_Khitomer.png"
                            height="24"
                            title="Cross-Faction"
                            alt="Cross-Faction"
                        />
                    </label>

                    <input
                        type="radio"
                        name="faction"
                        id="Federation-checkbox"
                        className="btn-check"
                        value="Federation"
                        checked={data.faction === "Federation"}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="Federation-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        <img
                            src="/img/Faction_FED25.png"
                            height="24"
                            alt="Federation"
                            title="Federation"
                        />
                    </label>

                    <input
                        type="radio"
                        name="faction"
                        id="Klingon Empire-checkbox"
                        className="btn-check"
                        value="Klingon Empire"
                        checked={data.faction === "Klingon Empire"}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="Klingon Empire-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        <img
                            src="/img/Faction_KDF.png"
                            height="24"
                            title="Klingon Defense Force"
                            alt="Klingon Defense Force"
                        />
                    </label>

                    <input
                        type="radio"
                        name="faction"
                        id="Romulan Republic-checkbox"
                        className="btn-check"
                        value="Romulan Republic"
                        checked={data.faction === "Romulan Republic"}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="Romulan Republic-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        <img
                            src="/img/Faction_Romulan_republic.png"
                            height="24"
                            alt="Romulan Republic"
                            title="Romulan Republic"
                        />
                    </label>

                    <input
                        type="radio"
                        name="faction"
                        id="Dominion-checkbox"
                        className="btn-check"
                        value="Dominion"
                        checked={data.faction === "Dominion"}
                        onChange={handleFormChange}
                    />
                    <label
                        htmlFor="Dominion-checkbox"
                        className="btn btn-outline-primary border-secondary"
                    >
                        <img
                            src="/img/Faction_Dominion.png"
                            height="24"
                            title="Dominion"
                            alt="Dominion"
                        />
                    </label>
                </div>
            </div>

            <div className="mb-3">
                <div className="mb-1">
                    <label htmlFor="currency" className="form-label mb-0">
                        Currency
                    </label>

                    <div
                        className="checkbox-grid"
                        role="group"
                        aria-label="currency control group"
                    >
                        <input
                            type="checkbox"
                            name="currency"
                            id="all-currency-checkbox"
                            className="btn-check"
                            checked={!data.currency || !data.currency.length}
                            value=""
                            onChange={clearCurrencies}
                        />
                        <label
                            htmlFor="all-currency-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            ♾️
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="ec-checkbox"
                            className="btn-check"
                            value="EC"
                            checked={data.currency && data.currency.includes("EC")}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="ec-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Energy_credit.png"
                                alt="Energy Credits"
                                title="Energy Credits"
                                height="24"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="zen-checkbox"
                            className="btn-check"
                            value="zen"
                            checked={data.currency && data.currency.includes("zen")}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="zen-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/120px-Zen_icon.png"
                                alt="Zen"
                                title="Zen"
                                height="24"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="dil-checkbox"
                            className="btn-check"
                            value="dil"
                            checked={data.currency && data.currency.includes('dil')}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="dil-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Dilithium_icon.png"
                                height="24"
                                alt="Dilithium"
                                title="Dilithium"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="fsm-checkbox"
                            className="btn-check"
                            value="FSM"
                            checked={data.currency && data.currency.includes('FSM')}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="fsm-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Fleet_Ship_Module_icon.png"
                                height="24"
                                alt="Fleet Ship Module"
                                title="Fleet Ship Module"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="lobi-checkbox"
                            className="btn-check"
                            value="LC"
                            checked={data.currency && data.currency.includes("LC")}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="lobi-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Lobi_Crystal_icon.png"
                                height="24"
                                alt="Lobi Crystals"
                                title="Lobe Crystals"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="ppp-checkbox"
                            className="btn-check"
                            value="PPP5"
                            checked={data.currency && data.currency.includes('PPP5')}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="ppp-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Epic_Prize_Token_-_Phoenix_Prize_Pack_icon.png"
                                height="24"
                                alt="Pheonix Prize Pack"
                                title="Pheonix Prize Pack"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="r&d-checkbox"
                            className="btn-check"
                            value="R&D"
                            checked={data.currency && data.currency.includes("R&D")}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="r&d-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/Special_Requisition_Choice_Pack_-_Tier_6_Promotional_Ship_Choice_Pack_icon.png"
                                height="24"
                                alt="R&D Pack"
                                title="R&D Pack"
                            />
                        </label>

                        <input
                            type="checkbox"
                            name="currency"
                            id="lb-checkbox"
                            className="btn-check"
                            value="LB"
                            checked={data.currency && data.currency.includes("LB")}
                            onChange={handleMultiCheckboxChange}
                        />
                        <label
                            htmlFor="lb-checkbox"
                            className="btn btn-outline-primary border-secondary"
                        >
                            <img
                                src="/img/currencies/120px-Generic_Lock_Box_v2.png"
                                height="24"
                                alt="Lockbox"
                                title="Lockbox"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <label className="form-label mb-1">Equipment</label>
            <div className="form-check form-switch mb-3">
                <input
                    className="form-check-input"
                    //value="1"
                    onChange={handleCheckboxChange}
                    name="can_dual_cannons"
                    type="checkbox"
                    id="can_dual_cannons"
                    checked={data.can_dual_cannons ? true : false}
                />
                <label className="form-check-label" htmlFor="can_dual_cannons">
                    Can Equip Dual Cannons
                </label>
            </div>

            <div className="form-check form-switch mb-3">
                <input
                    className="form-check-input"
                    value="1"
                    onChange={handleCheckboxChange}
                    name="can_experimental_weapon"
                    type="checkbox"
                    id="can_experimental_weapon"
                    checked={data.can_experimental_weapon ? true : false}
                />
                <label
                    className="form-check-label"
                    htmlFor="can_experimental_weapon"
                >
                    Can Equip Experimental Weapon
                </label>
            </div>

            <div className="form-check form-switch mb-3">
                <input
                    className="form-check-input"
                    value="1"
                    onChange={handleCheckboxChange}
                    name="can_secondary_deflector"
                    type="checkbox"
                    id="can_secondary_deflector"
                    checked={data.can_secondary_deflector ? true : false}
                />
                <label
                    className="form-check-label"
                    htmlFor="can_secondary_deflector"
                >
                    Can Equip Secondary Deflector
                </label>
            </div>

            <label htmlFor="" className="form-label mb-1">
                Tier
            </label>
            <div className="form-control d-flex justify-content-between tier-selector bg-primary border border-secondary p-1 mb-3">
                <input
                    className="d-none"
                    type="radio"
                    value=""
                    name="tier"
                    id="tier-0"
                    checked={!data.tier || data.tier === ""}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-0">
                    ♾️
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="1"
                    name="tier"
                    id="tier-1"
                    checked={data.tier === "1"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-1">
                    <img alt="Tier 1" src="/img/tier-1.png" />
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="2"
                    name="tier"
                    id="tier-2"
                    checked={data.tier === "2"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-2">
                    <img alt="Tier 2" src="/img/tier-2.png" />
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="3"
                    name="tier"
                    id="tier-3"
                    checked={data.tier === "3"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-3">
                    <img alt="Tier 3" src="/img/tier-3.png" />
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="4"
                    name="tier"
                    id="tier-4"
                    checked={data.tier === "4"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-4">
                    <img alt="Tier 4" src="/img/tier-4.png" />
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="5"
                    name="tier"
                    id="tier-5"
                    checked={data.tier === "5"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-5">
                    <img alt="Tier 5" src="/img/tier-5.png" />
                </label>

                <input
                    className="d-none"
                    type="radio"
                    value="6"
                    name="tier"
                    id="tier-6"
                    checked={data.tier === "6"}
                    onChange={handleFormChange}
                />
                <label className="p-2 rounded" htmlFor="tier-6">
                    <img alt="Tier 6" src="/img/tier-6.png" />
                </label>
            </div>

            <div className="mb-3">
                <label htmlFor="hangar_bays" className="form-label mb-1">
                    Hangar Bays
                </label>
                <input
                    className="form-range"
                    value={data.hangar_bays ? data.hangar_bays : 0}
                    type="range"
                    name="hangar_bays"
                    id="hangar_bays"
                    min={0}
                    max={state.max_hangar_bays}
                    onChange={handleFormChange}
                />
                <div className="form-text mt-0">
                    {data.hangar_bays > 0 && (
                        <>
                            Require at least {data.hangar_bays} Hangar{" "}
                            {data.hangar_bays === "1" ? "Bay" : "Bays"}
                        </>
                    )}
                </div>
            </div>

            <div className="mb-3">
                <label htmlFor="" className="form-label mb-1">
                    Type
                </label>
                <select
                    name="type"
                    id="type"
                    className="form-select bg-primary border-primary text-white"
                    multiple
                    onChange={handleMultiSelect}
                    value={data.type}
                >
                    {state &&
                        state.types.map(function (type, index) {
                            return (
                                <option key={index} value={type}>
                                    {type}
                                </option>
                            );
                        })}
                </select>
                <div className="form-text">
                    Hold <kbd>CTRL</kbd> to multi or unselect an option.
                </div>
            </div>

            <div className="mb-3">
                <label htmlFor="" className="form-label mb-1">
                    Abilities
                </label>
                <select
                    name="abilities"
                    id="abilities"
                    className="form-select bg-primary border-primary text-white"
                    multiple
                    onChange={handleMultiSelect}
                    value={data.abilities}
                >
                    {state.abilities &&
                        state.abilities.map((ability, index) => (
                            <option key={index} value={ability}>
                                {ability}
                            </option>
                        ))}
                </select>
                <div className="form-text">
                    Hold <kbd>CTRL</kbd> to multi or unselect an option.
                </div>
            </div>

            <div className="mb-3">
                <label htmlFor="admirality_ability" className="form-label mb-1">
                    Admiralty Ability
                </label>
                <select
                    name="admirality_ability"
                    id="admirality_ability"
                    className="form-select bg-primary border-primary text-white"
                    onChange={handleFormChange}
                    value={data.admirality_ability}
                >
                    <option value="">Select an Ability</option>
                    {state.admirality_abilities &&
                        state.admirality_abilities.map((ability, index) => (
                            <option key={index} value={ability}>
                                {ability}
                            </option>
                        ))}
                </select>
            </div>

            <div className="mb-3">
                <label htmlFor="released_after" className="form-label mb-1">Released After</label>
                    
                    <input 
                        className="form-control bg-primary border-primary text-white"
                        type="date"
                        id="released_after"
                        name="released_after"
                        value={data.released_after}
                        min="2010-02-02"
                        max={data.released_before}
                        onChange={handleFormChange}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="released_before" className="form-label mb-1">Released Before</label>

                    <input 
                        className="form-control bg-primary border-primary text-white"
                        type="date"
                        id="released_before"
                        name="released_before"
                        value={data.released_before}
                        min={data.released_after}
                        max={new Date().toISOString().slice(0, 10)}
                        onChange={handleFormChange}
                    />
                </div>
        
        </fieldset>
    );
}

export default Sidebar;
